module.exports = __webpack_public_path__ + "img/bg1-large.bd9e6b09.png";